<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3>
          <i class="fas fa-chart-line"></i> Relatórios - Resultado Campanha
        </h3>
      </div>
    </div>
    <Tables
      ref="tableGrid"
      :columns="columns"
      :showSearch="true"
      :showReload="false"
      :showTipFooter="false"
      v-on:Search="onShowSearch"
      v-on:Load="onLoad"
      v-on:Reload="onLoad"
    >
      <template slot="table-header-buttons">
        <a
          href="javascript:void(0);"
          v-b-tooltip.hover
          :title="'Exportar'"
          @click="onExportExcel"
        >
          <i class="fas fa-file-excel text-third" style="font-size: 15px"></i>
        </a>
      </template>
      <tr v-for="(obj, index) in this.objList" v-bind:key="index">
        <template>
          <TableColumn
            :IsText="true"
            :status="1"
            :value="obj.campanha ? obj.campanha : 'NÃO POSSUI'"
          />
          <TableColumn
            :IsText="true"
            :status="1"
            :value="obj.documento ? obj.documento : 'NÃO POSSUI'"
          />
          <TableColumn
            :IsText="true"
            :status="1"
            :value="obj.nome ? obj.nome : 'NÃO POSSUI'"
          />
          <TableColumn
            :IsText="true"
            :status="1"
            :value="obj.email ? obj.email : 'NÃO POSSUI'"
          />
          <TableColumn
            :IsText="true"
            :status="1"
            :value="obj.celular ? obj.celular : 'NÃO POSSUI'"
          />
          <TableColumn
            :IsText="true"
            :status="1"
            :value="obj.quantidadeVisualizacao > 0 ? 'SIM' : 'NÃO'"
          />
          <TableColumn
            :IsDateOnly="true"
            :status="1"
            :value="obj.dataPrimeiraVisualizacao"
          />
          <TableColumn
            :IsDateOnly="true"
            :status="1"
            :value="obj.dataUltimaVisualizacao"
          />
          <TableColumn
            :IsText="true"
            :status="1"
            :value="obj.conversao ? 'SIM' : 'NÃO'"
          />
          <TableColumn
            :IsDateOnly="true"
            :status="1"
            :value="obj.dataConversao"
          />
          <TableColumn
            :IsDateOnly="true"
            :status="1"
            :value="obj.dataEnvioRealizado"
          />
        </template>
      </tr>
    </Tables>

    <ModalCard
      ref="ModalCard"
      v-if="selectedCard"
      :boardColumns="[]"
      @hideModal="closeCard"
      :key="selectedCard"
      :cardId="selectedCard"
    />
    <SidebarSearch @search="onSearch" />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'
import ReportEnvioCampanhaRepository from '@/shared/http/repositories/reports/reportEnvioCampanha'
import SidebarSearch from '@/views/private/reports/campanha/envioCampanha/search/SidebarRelatorioCampanhaEnvio.vue'

export default {
  name: 'ReportEnvioCampanha',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null,
      filters: null,
      columns: ['CAMPANHA',
        'CPF/CNPJ',
        'NOME',
        'E-MAIL',
        'TELEFONE',
        'VISUALIZOU',
        'DATA 1ª VISUALIZAÇÃO',
        'DATA ULT. VISUALIZAÇÃO',
        'CLICOU',
        'DATA CLICK',
        'DATA DISPARO'
      ],
      columnsOpt: [],
      selectedCard: null
    }
  },
  components: {
    ModalCard, SidebarSearch
  },
  // mounted () {
  //   this.$eventHub.on('Filter', ({ filters }) => {
  //     this.filters = filters
  //     this.$refs.tableGrid.Clear()
  //     this.$nextTick(() => {
  //       this.onLoadAll()
  //     })
  //   })
  // },
  // beforeDestroy () {
  //   this.$eventHub.off('Filter')
  //   Tools.MinimizedASidebar()
  // },
  methods: {
    onLoad () {
      if (this.filters) {
        this.onLoadAll()
      } else {
        this.filters = {
          campanha: null,
          dataCriacaoInicial: null,
          dataCriacaoFinal: null,
          dataEnvioInicial: null,
          dataEnvioFinal: null,
          canal: null,
          modelo: null,
          lista: null,
          situacao: null
        }
        this.onLoadAll()
      }
    },
    onLoadAll () {
      loading.push()
      ReportEnvioCampanhaRepository.GetAllCampanhaReport(this.filters, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch(this.onException)
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onExportExcel () {
      loading.push()
      ReportEnvioCampanhaRepository.ExportAllCampanhaReport(this.filters)
        .then((response) => {
          loading.close()
          const fileStartName = this.moment().format('YYYYMMDDhhmm')
          const blob = new Blob([this.base64ToArrayBuffer(response.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const url = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = fileStartName + '_RelatorioEnvioCampanha.xlsx'
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch(this.onException)
    },
    base64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    setVisibleColumns () {
      this.columns = []
      for (let i = 0; i < this.columnsOpt.length; i++) {
        if (this.columnsOpt[i].value) {
          this.columns.push(this.columnsOpt[i].label)
        }
      }
    },
    openCard (cardId) {
      this.selectedCard = cardId
    },
    closeCard () {
      this.selectedCard = null
    }
  }
}

</script>
<style>
.popover-header {
  background-color: #04a791;
  color: #eceff1
}
</style>



// WEBPACK FOOTER //
// src/views/private/reports/campanha/envioCampanha/reportEnvioCampanha.vue